document.addEventListener("DOMContentLoaded", () => {
  const cont = document.querySelector("#Details-menu-drawer-container");
  if (!cont) return;

  const drawer = cont.querySelector("#menu-drawer");
  const sum = cont.querySelector("summary");
  const keyMenu = "mk-last-menu";
  const keyPromo = "mk-last-promo";
  const keyNavFlag = "mk-nav-behavior"; // "reset" hoặc "keep" (hoặc null)
  const isMb = () => innerWidth < 990;

  const iconHam = cont.querySelector(".icon-hamburger");
  const iconClose = cont.querySelector(".icon-close");

  const toggleIcons = (open) => {
    if (!iconHam || !iconClose) return;
    iconHam.style.display = open ? "none" : "inline-flex";
    iconClose.style.display = open ? "inline-flex" : "none";
  };

  const lockBody = (lock) => {
    document.body.classList.toggle("drawer-open", lock);
    document.body.style.overflow = lock ? "hidden" : "";
  };

  const openDrawer = () => {
    lockBody(true);
    drawer.setAttribute("aria-hidden", "false");
    toggleIcons(true);
  };

  const closeDrawer = () => {
    lockBody(false);
    drawer.setAttribute("aria-hidden", "true");
    toggleIcons(false);
    cont.removeAttribute("open");
  };

  // toggle menu icon
  sum?.addEventListener("click", (e) => {
    e.preventDefault();
    cont.toggleAttribute("open");
  });

  // click overlay
  drawer.addEventListener("click", (e) => e.target === drawer && closeDrawer());

  // esc
  addEventListener("keydown", (e) => e.key === "Escape" && cont.open && closeDrawer());

  // resize
  addEventListener("resize", () => {
    if (!isMb() && cont.open) closeDrawer();
    toggleIcons(cont.open);
  });

  // theo dõi trạng thái <details open>
  new MutationObserver(() => {
    if (isMb()) cont.open ? openDrawer() : closeDrawer();
    else closeDrawer();
  }).observe(cont, { attributes: true, attributeFilter: ["open"] });

  // helpers
  const save = (k, v) => sessionStorage.setItem(k, JSON.stringify(v));
  const load = (k) => JSON.parse(sessionStorage.getItem(k) || "[]");
  const clear = (k) => sessionStorage.removeItem(k);

  // click link thường (lv1, lv2, lv3)
  drawer.querySelectorAll("a").forEach((a) => {
    // only care about anchors that are part of menu (have either data-handle or data-parent or inside menu)
    if (!a.closest(".menu-drawer__menu") && !a.classList.contains("mobile-mega-item")) return;

    a.addEventListener("click", () => {
      // tìm details cha (nếu có)
      const parent = a.closest("details[data-handle]");
      // build ancestor handles: unshift từ dưới lên (lv1, lv2, ...)
      const arr = [];
      if (parent) {
        let p = parent;
        while (p) {
          arr.unshift(p.dataset.handle);
          p = drawer.querySelector(`details[data-handle="${p.dataset.parent}"]`);
        }
      }

      // xác định handle thực sự ứng với link được click:
      // ưu tiên a.dataset.handle (thường lv3), rồi a.dataset.parent (thường lv1 direct), rồi parent?.dataset.handle (nếu a nằm trong summary lv2)
      const clickedHandle = a.dataset?.handle ?? a.dataset?.parent ?? parent?.dataset?.handle;

      // tránh duplicate: nếu clickedHandle khác với phần tử cuối cùng thì push
      if (clickedHandle && clickedHandle !== arr[arr.length - 1]) {
        arr.push(clickedHandle);
      }

      // lưu đường dẫn sâu nhất
      save(keyMenu, arr);
      clear(keyPromo);

      // quyết định behavior khi reload:
      // - nếu arr.length >= 3 => giữ (open sâu) để mở panel chứa lv3
      // - nếu arr.length < 3 => reset về lv1 mặc định khi reload
      if (arr.length >= 3) {
        sessionStorage.setItem(keyNavFlag, "keep");
      } else {
        sessionStorage.setItem(keyNavFlag, "reset");
      }
    });
  });

  // click promo (giữ nguyên)
  drawer.querySelectorAll(".mobile-mega-item").forEach((a) => {
    a.addEventListener("click", (e) => {
      const panel = a.closest(".menu-drawer__submenu");
      if (panel?.id) {
        sessionStorage.setItem(keyPromo, panel.id);
        clear(keyMenu);
        sessionStorage.removeItem(keyNavFlag);
      }
    });
  });

  // khôi phục trạng thái
  const menu = load(keyMenu);
  const promo = sessionStorage.getItem(keyPromo);
  const navFlag = sessionStorage.getItem(keyNavFlag); // "reset" | "keep" | null

  if (navFlag === "reset") {
    // user đã click link không sâu (lv1 hoặc lv2) → reset menu về mặc định
    sessionStorage.removeItem(keyNavFlag);
    drawer.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
  } else if (menu.length) {
    // có menu lưu → mở đúng chuỗi details tương ứng
    // (nếu menu chứa 3 phần tử thì sẽ mở lv1 -> lv2 -> panel chứa lv3)
    menu.forEach((h) =>
      drawer.querySelector(`details[data-handle="${h}"]`)?.setAttribute("open", "")
    );
  } else if (promo) {
    const el = drawer.querySelector(`#${promo}`);
    el?.closest("details[data-handle]")?.setAttribute("open", "");
  } else {
    // mặc định: đóng tất cả
    drawer.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
  }

  // fix mất icon close khi load chậm
  requestAnimationFrame(() => toggleIcons(cont.open));
});

// Hiệu ứng nhấn icon-caret-frame trên mobile, không ảnh hưởng logic menu
document.addEventListener(
  "touchstart",
  (e) => {
    const icon = e.target.closest(".icon-caret-frame");
    if (!icon) return;
    icon.classList.add("active-touch");
    setTimeout(() => icon.classList.remove("active-touch"), 180);
  },
  { passive: true }
);